export interface ScanPreviewDTO {
  scanCustomerId?: number;
  scanServiceId?: number;
  scanStyleId?: number;
  scanStageId?: number;
  scanVehicleId?: number;
  scanUrl?: string;
}
